/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block}.link__link[_ngcontent-%COMP%]{color:inherit;font-size:inherit;display:inline-block;line-height:1;text-decoration:none}.link__link[_ngcontent-%COMP%]:focus{outline:0}"];
export { styles as styles };
